import React, { memo } from 'react'
import { string } from 'prop-types'

export const BNDLogo = memo(({ color = '#000000', height = '100%', width = '100%' }) => {
	return (
		<svg
			version="1.1"
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			width={width}
			height={height}
			viewBox="0 0 336.284 105.6"
			enableBackground="new 0 0 336.284 102.6"
			xmlSpace="preserve"
		>
			<g>
				<path
					fill={color}
					stroke={color}
					d="M0.951,44.15h6.07V6.141h-6.07V0.828h22.144c3.519,0,6.14,0.346,8.555,1.449
                    c3.863,1.725,6.691,5.726,6.691,10.969c0,4.76-2.346,8.553-6.14,10.484v0.139c5.243,1.518,8.071,6.277,8.071,11.797
                    c0,6.416-3.933,11.244-8.968,12.969c-2.346,0.758-4.622,0.896-7.312,0.896H0.951V44.15z M24.13,21.316
                    c4.415,0,7.175-3.035,7.175-7.449c0-2.829-1.104-5.244-3.174-6.416c-1.38-0.689-2.966-0.967-5.036-0.967H13.92v14.832H24.13z
                    M24.268,43.875c1.38,0,3.035-0.139,4.347-0.689c2.828-1.174,4.622-4.209,4.622-7.865c0-5.035-3.312-8.348-8.417-8.348H13.92
                    v16.902H24.268z"
				></path>
				<path
					fill={color}
					stroke={color}
					d="M50.761,6.141h-6.14V0.828h19.178v5.312h-6.14v25.18c0,3.172,0.621,5.932,1.862,7.932
                    c2.001,3.174,5.795,4.967,10.486,4.967c4.622,0,8.485-1.793,10.485-5.104c1.173-2.002,1.863-4.691,1.863-7.865V6.141h-6.14V0.828
                    h19.108v5.312h-6.07v25.248c0,4.621-1.242,8.83-3.381,11.865c-3.312,4.691-9.244,7.105-15.866,7.105
                    c-6.898,0-12.693-2.621-16.005-7.105c-2.276-3.104-3.242-7.174-3.242-11.865V6.141z"
				></path>
				<path
					fill={color}
					stroke={color}
					d="M104.366,34.906v3.588c0,3.588,4.621,5.725,9.727,5.725c5.588,0,9.658-2.621,9.658-7.449
                    c0-5.656-5.727-7.52-11.729-9.865c-6.414-2.414-12.969-5.174-12.969-13.797C99.053,3.933,106.434,0,114.645,0
                    c7.312,0,14.762,2.76,14.762,8.072v5.725h-6.416v-3.379c0-2.829-4.346-4.347-8.346-4.347c-4.762,0-8.555,2.208-8.555,6.691
                    c0,5.174,4.898,6.898,10.348,8.968c7.174,2.691,14.279,5.449,14.279,14.486c0,9.314-7.588,14.143-16.625,14.143
                    c-7.588,0-16.074-3.381-16.074-10.348v-5.105H104.366z"
				></path>
				<path
					fill={color}
					stroke={color}
					d="M136.86,44.15h6.07V6.141h-6.07V0.828h19.107v5.312h-6.139v38.01h6.139v5.381H136.86
                    V44.15z"
				></path>
				<path
					fill={color}
					stroke={color}
					d="M163.903,44.15h6.07V6.141h-6.07V0.828h12.9l23.938,34.906
                    c0.828,1.379,1.656,3.518,1.656,3.518h0.207c0,0-0.346-2.414-0.346-3.932V6.141h-6.209V0.828h19.248v5.312h-6.141v43.391h-6.76
                    l-23.939-34.906c-0.896-1.379-1.654-3.518-1.654-3.518h-0.207c0,0,0.344,2.414,0.275,3.932V44.15h6.277v5.381h-19.246V44.15z"
				></path>
				<path
					fill={color}
					stroke={color}
					d="M221.372,44.15h6.07V6.141h-6.07V0.828h35.25v11.314h-6V6.484H234.34v15.66h17.246v5.656
                    H234.34v16.074h17.453v-5.863h6.002v11.52h-36.424V44.15z"
				></path>
				<path
					fill={color}
					stroke={color}
					d="M270.284,34.906v3.588c0,3.588,4.621,5.725,9.727,5.725c5.588,0,9.658-2.621,9.658-7.449
                    c0-5.656-5.727-7.52-11.729-9.865c-6.416-2.414-12.969-5.174-12.969-13.797c0-9.175,7.381-13.107,15.59-13.107
                    c7.312,0,14.764,2.76,14.764,8.072v5.725h-6.416v-3.379c0-2.829-4.346-4.347-8.348-4.347c-4.76,0-8.553,2.208-8.553,6.691
                    c0,5.174,4.896,6.898,10.348,8.968c7.174,2.691,14.279,5.449,14.279,14.486c0,9.314-7.588,14.143-16.625,14.143
                    c-7.588,0-16.074-3.381-16.074-10.348v-5.105H270.284z"
				></path>
				<path
					fill={color}
					stroke={color}
					d="M309.124,34.906v3.588c0,3.588,4.623,5.725,9.727,5.725c5.588,0,9.658-2.621,9.658-7.449
                    c0-5.656-5.725-7.52-11.727-9.865c-6.416-2.414-12.969-5.174-12.969-13.797c0-9.175,7.381-13.107,15.59-13.107
                    c7.312,0,14.762,2.76,14.762,8.072v5.725h-6.414v-3.379c0-2.829-4.348-4.347-8.348-4.347c-4.76,0-8.555,2.208-8.555,6.691
                    c0,5.174,4.898,6.898,10.348,8.968c7.176,2.691,14.281,5.449,14.281,14.486c0,9.314-7.59,14.143-16.627,14.143
                    c-7.588,0-16.072-3.381-16.072-10.348v-5.105H309.124z"
				></path>
				<path
					fill={color}
					d="M0.18,97.701h4.789v-29.99H0.18V63.52h10.178l18.887,27.541c0.653,1.088,1.306,2.775,1.306,2.775h0.164
                    c0,0-0.272-1.904-0.272-3.102V67.711h-4.898V63.52h15.186v4.191h-4.845v34.234H30.55L11.664,74.406
                    c-0.708-1.09-1.307-2.777-1.307-2.777h-0.163c0,0,0.271,1.906,0.218,3.104v22.969h4.953v4.244H0.18V97.701z"
				></path>
				<path
					fill={color}
					d="M44.486,97.701h4.789v-29.99h-4.789V63.52h27.812v8.926h-4.735v-4.463H54.719v12.355h13.606v4.463H54.719
                    v12.682h13.771v-4.625h4.734v9.088H44.486V97.701z"
				></path>
				<path
					fill={color}
					d="M76.109,63.52h13.661v4.191h-4.571l5.986,25.199c0.272,1.361,0.436,2.885,0.436,2.885h0.164
                    c0,0,0.217-1.523,0.544-2.885l8.056-29.391h4.625l8.002,29.391c0.381,1.361,0.543,2.885,0.543,2.885h0.219
                    c0,0,0.109-1.523,0.381-2.885l5.986-25.199h-4.572V63.52h13.717v4.191h-3.701l-8.6,34.234h-6.205l-7.512-27.268
                    c-0.381-1.361-0.488-3.049-0.488-3.049h-0.219c0,0-0.109,1.688-0.49,3.049l-7.51,27.268h-6.205l-8.545-34.234h-3.701V63.52z"
				></path>
				<path
					fill={color}
					d="M136.745,90.408v2.83c0,2.83,3.646,4.518,7.674,4.518c4.408,0,7.621-2.068,7.621-5.879
                    c0-4.463-4.518-5.934-9.254-7.783c-5.062-1.904-10.232-4.082-10.232-10.885c0-7.24,5.824-10.342,12.301-10.342
                    c5.77,0,11.648,2.176,11.648,6.367v4.518h-5.062v-2.666c0-2.232-3.43-3.43-6.586-3.43c-3.756,0-6.748,1.742-6.748,5.279
                    c0,4.082,3.863,5.443,8.164,7.076c5.66,2.123,11.266,4.299,11.266,11.43c0,7.348-5.986,11.158-13.117,11.158
                    c-5.986,0-12.682-2.668-12.682-8.164v-4.027H136.745z"
				></path>
				<path
					fill={color}
					d="M175.28,97.701h4.791v-29.99h-4.791V63.52h16.383c3.213,0,5.607,0.164,8.166,0.926
                    c7.348,2.285,12.137,8.926,12.137,18.287c0,9.309-4.627,15.785-12.137,18.18c-2.504,0.816-5.062,1.033-8.111,1.033H175.28V97.701z
                    M191.391,97.482c2.504,0,4.572-0.217,6.531-0.979c5.172-1.797,8.383-6.75,8.383-13.771c0-7.074-3.211-12.027-8.328-13.879
                    c-2.123-0.762-4.082-0.871-6.586-0.871h-5.879v29.5H191.391z"
				></path>
				<path
					fill={color}
					d="M213.817,97.701h3.701l12.246-34.182h6.15l12.246,34.182h3.701v4.244h-13.334v-4.244h4.082l-2.994-8.545
                    H226.01l-2.994,8.545h4.137v4.244h-13.336V97.701z M238.256,84.801l-4.682-13.334c-0.545-1.578-0.652-2.939-0.652-2.939h-0.164
                    c0,0-0.164,1.361-0.652,2.939l-4.736,13.334H238.256z"
				></path>
				<path
					fill={color}
					d="M254.586,97.701h4.789v-29.99h-4.789V63.52h15.076v4.191h-4.844v29.99h4.844v4.244h-15.076V97.701z"
				></path>
				<path
					fill={color}
					d="M274.67,97.701h4.789V67.982h-4.789V63.52h15.076v4.463h-4.844v29.5h13.389v-6.205h4.789v10.668h-28.41
                    V97.701z"
				></path>
				<path
					fill={color}
					d="M311.573,97.701h4.844V85.672l-10.775-17.961h-3.648V63.52h13.227v4.191h-4.027l7.131,12.082
                    c0.436,0.816,0.762,1.633,0.762,1.633h0.107c0,0,0.328-0.816,0.816-1.633l7.131-12.082h-3.973V63.52h13.117v4.191h-3.646
                    L321.86,85.672v12.029h4.844v4.244h-15.131V97.701z"
				></path>
			</g>
		</svg>
	)
})

BNDLogo.propTypes = {
	height: string,
	width: string,
	color: string,
}
